<template>
  <div class="LandingPages">
    <h1>Landing pages</h1>
  </div>
</template>

<script>
export default {
  name: 'LandingPages',
  data() {
    return {
      landingPages: [],
    }
  },
  methods: {},
  mounted() {},
}
</script>
